import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class AbstractApproval extends AbstractModel {
  @autoserialize
  createdByUserId: number;

  @autoserialize
  active: boolean;

  @autoserialize
  effective: boolean;

  @autoserializeAs(Date)
  effectiveDate: Date;

  static OnSerialized(instance: AbstractApproval, json: any): void {
    super.OnSerialized(instance, json);
    if (!isNullOrUndefined(instance.effectiveDate)) {
      json.effectiveDate = DateUtil.serializeLocalDate(instance.effectiveDate);
    }
  }

  static OnDeserialized(instance: AbstractApproval, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['effectiveDate'])) {
      instance.effectiveDate = DateUtil.deserializeInstant(json['effectiveDate']);
    }
  }
}
